<template>
    <div class="">
        <div class="row no-gutters py-3">
            <div class="col-sm-6 px-4 company-form-box-title">Bank Information</div>
            <template v-if="$acl['banks'] == 2"><div class="col-sm-6 px-4 cursor-pointer text-right company-form-box-title" @click="addNew()"><button class="edit-icon"><i class="fa fa-plus"></i></button></div></template>
        </div>

        <!-- alpha fix- maked the title dynamic  -->
        <b-modal id="bv-modal-bank" size="lg" hide-footer :title=bank_info_title>
            <b-form @submit.stop.prevent="onSubmit" >
                <ul class="list-group mb-3 " v-if='errormsg'>
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>
                <div class="clearfix">

                    <ul class="list-group mb-3 " v-if='errormsg'>
                        <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                    </ul>

                    <div class="col-md-6 float-left">
                        <input type="hidden" v-model="fdata.id" name="id">
                        <b-form-group id="beneficiary_name-group" label="Beneficiary Name" class="required-field" label-for="beneficiary_name" :style="{ marginBottom: veeErrors.has('account_no') && !veeErrors.has('beneficiary_name') ? '39px' : '' }">
                            <b-form-input id="beneficiary_name" name="beneficiary_name" v-model="fdata.beneficiary_name" v-validate="{ required: true, min: 3 }" :state="validateState('beneficiary_name')" aria-describedby="beneficiary_name-feedback" data-vv-as="Beneficiary Name"></b-form-input>
                            <b-form-invalid-feedback id="beneficiary_name-feedback">{{ veeErrors.first('beneficiary_name') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="bank_name-group" label="Bank Name" class="required-field" label-for="bank_name">
                            <b-form-select id="bank_name" name="bank_name" v-model="fdata.bank_name" v-validate="{ required: true }" :options="bank_names" :state="validateState('bank_name')" aria-describedby="bank_name-feedback" data-vv-as="Bank Name"></b-form-select>
                            <b-form-invalid-feedback id="bank_name-feedback">{{ veeErrors.first('bank_name') }}</b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group id="routing_number-group" label="Routing No." class="" label-for="routing_number">
                            <b-form-input id="routing_number" name="routing_number" v-model="fdata.routing_number" v-validate="{ decimal:3 }" :state="validateState('routing_number')" aria-describedby="routing_number-feedback" data-vv-as="Routing No."></b-form-input>
                            <b-form-invalid-feedback id="routing_number-feedback">{{ veeErrors.first('routing_number') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 float-right">
                        <b-form-group id="account_no-group" label="Account No." class="required-field" label-for="account_no" :style="{ marginBottom: veeErrors.has('beneficiary_name') && !veeErrors.has('account_no') ? '39px' : '' }">
                            <b-form-input id="account_no" name="account_no" v-model="fdata.account_no" v-validate="{ required: true, min: 3, decimal:3 }" :state="validateState('account_no')" aria-describedby="account_no-feedback" data-vv-as="Account No."></b-form-input>
                            <b-form-invalid-feedback id="account_no-feedback">{{ veeErrors.first('account_no') }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="branch_name-group" label="Branch Name" class="" label-for="branch_name">
                            <b-form-input id="branch_name" name="branch_name" v-model="fdata.branch_name" ></b-form-input>
                        </b-form-group>

                    </div>
                    <div class="col-md-12 btn-wrapper text-center pt-5 my-clearfix">
                        <b-button class="custom-wizard-btn mr-2" variant="primary" @click="resetForm()">Reset</b-button>
                        <b-button type="submit" class="" variant="primary">Submit</b-button>
                    </div>
                </div>

            </b-form>
        </b-modal>

        <b-overlay :show="showoverlay_list" rounded="sm">
            <div v-if="banks.length > 0" >
                <div class="bank-info-inner" v-for="bank in banks" :key="bank.id">
                    <ul class="bank-info" v-if="bank.is_primary=='1'" :class="{ 'border-top pt-3' : bi==1}">
                        <li class="px-4">
                            <div class="title col-6">Beneficiary Name</div>
                            <div class="text col-6">
                                {{bank.beneficiary_name}}
                                <div class="action management-bank-action"  >
                                    <b-button class="border-0 rounded py-0" variant="outline-secondary" type="button" title="This is Primary Account" v-if="bank.is_primary=='1'"><b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon></b-button>
                                    <b-button-toolbar class="float-right position-relative" v-if="$acl['banks'] == 2">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu p-1 bank-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="">
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Bank Account Info" @click="editBankInfo(bank.id)">
                                                    <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                                                </b-button>
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Bank Account Info" @click="deleteBankInfo(bank.id)">
                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                </b-button>

                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" v-if="bank.is_primary=='0'" title="Make This Account Primary" @click="showPrimaryModal(bank.id)">
                                                    <i class="fa fa-key" aria-hidden="true"></i> Make Primary
                                                    </b-button>

                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" type="button" title="This is Primary Account" v-if="bank.is_primary=='1'"><b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon> Primary Account</b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </div>
                        </li>
                         <li class="px-4">
                            <div class="title col-6">Bank Name</div>
                            <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.bank_name}}</template></div>
                        </li>
                        <li class="px-4">
                            <div class="title col-6">Branch Name</div>
                            <div class="text col-6"><template v-if="bank.branch_name != 'null'">{{bank.branch_name}}</template></div>
                        </li>
                        <li class="px-4">
                            <div class="title col-6">Bank Account No.</div>
                            <div class="text col-6">{{bank.account_no}}</div>
                        </li>
                        <li class="px-4">
                            <div class="title col-6">Routing Number</div>
                            <div class="text col-6"><template v-if="bank.routing_number != 'null'">{{bank.routing_number}}</template></div>
                        </li>
                    </ul>
                     <div v-else>
                        <ul class="bank-info" v-if="bi==1" :class="{ 'border-top' : bi==1}">
                            <li class="px-4">
                                <div class="title col-6">Beneficiary Name</div>
                                <div class="text col-6">{{bank.beneficiary_name}}</div>
                                <div class="action" v-if="$acl['banks'] == 2">
                                    <b-button-toolbar class="float-right position-relative">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="mt-n2">
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Bank Account Info" @click="editBankInfo(bank.id)">
                                                    <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                                                </b-button>
                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Bank Account Info" @click="deleteBankInfo(bank.id)">
                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                </b-button>

                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" v-if="bank.is_primary=='0'" title="Make This Account Primary" @click="showPrimaryModal(bank.id)">
                                                    <i class="fa fa-key" aria-hidden="true"></i> Make Primary
                                                    </b-button>

                                                <b-button class="border-0 rounded py-0" variant="outline-secondary" type="button" title="This is Primary Account" v-if="bank.is_primary=='1'"><b-icon icon="check-circle-fill" variant="success" aria-hidden="true" ></b-icon> Primary Account</b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </li>
                            <li class="px-4">
                                <div class="title col-6">Bank Name</div>
                                <div class="text col-6"><template v-if="bank.bank_name != 'null'">{{bank.bank_name}}</template></div>
                            </li>
                            <li class="px-4">
                                <div class="title col-6">Branch Name</div>
                                <div class="text col-6"><template v-if="bank.branch_name != 'null'">{{bank.branch_name}}</template></div>
                            </li>
                            <li class="px-4">
                                <div class="title col-6">Bank account No.</div>
                                <div class="text col-6">{{bank.account_no}}</div>
                            </li>
                            <li class="px-4">
                                <div class="title col-6">Routing Number</div>
                                <div class="text col-6"><template v-if="bank.routing_number != 'null'">{{bank.routing_number}}</template></div>
                            </li>
                        </ul>
                    </div>

                </div>
                <template v-if="banks.length > 0">
                    <div class="more-bank" v-if="bi==0">
                          <b-button class="border-0 rounded p-0" variant="outline-secondary" title="Show all" @click="showAll(1)">
                              Show All <i class="fa fa-angle-down"></i>
                          </b-button>
                    </div>
                    <div class="more-bank" v-if="bi==1">
                          <b-button class="border-0 rounded p-0" variant="outline-secondary" title="Show less" @click="showLess(0)">
                              Show Less <i class="fa fa-angle-up"></i>
                          </b-button>
                    </div>
                </template>
            </div>
        </b-overlay>

        <!--Make account primary modal-->
        <div>
        <b-modal id="make-primary-modal" title="Making it Primary?" hide-footer>
        Are You Sure to Make This Account Primary?
        <br />
        <div style="height: 10px;clear:both;"> &nbsp;</div>
        <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="makePrimary(selected_bank_id)"><i class="fa fa-key" aria-hidden="true"></i> Make Primary</a>
        &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('make-primary-modal')">Cancel</a>
        <div style="height: 5px;clear:both;"> &nbsp;</div>
        <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="30"></span>
        </b-modal>
        </div>
        <!--###########################-->


    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: ['bn' , 'flg'],
        data(){

            return {

                banks:[],
                bank_names: [
                    { value: null, text: "--Select--" },
                ],
                showoverlay_list : false,
                successmsg:'',
                errormsg:[],
                fdata: {employee_id: this.employeeid, beneficiary_name: this.bn, bank_name:null},

                selected_bank_id:0,
                loading:'',
                bi : 0,

                // alpha fix- added this
                bank_info_title:"Add Bank Info",
            }
        },
        methods:{

            getBankList: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/banklist/' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.bank_names = response.data;
                }.bind(this)).catch(function (error){this.serverError(error);});

            },

              showPrimaryModal: function(bankid)
              {
                this.selected_bank_id=bankid;
                this.$bvModal.show('make-primary-modal');
              },

             showAll :function(x)
            {
                this.bi = x;
            },
             showLess :function(x)
            {
                this.bi = x;
            },


            makePrimary: function(bankid)
            {
                //alert(bankid);

                if(!this.checkNet()) return false;

                this.loading='loading..';
                axios.get(this.$api_url+'/makeprimary/' , {
                    params: {
                        bank_id: bankid

                    }
                }).then(function(response){
                    this.$bvModal.hide('make-primary-modal');
                    this.getBankData();
                    this.loading='';
                }.bind(this)).catch(function (error){this.serverError(error);});

            },

            getBankData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/banks/' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.banks = response.data;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            editBankInfo:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/banks/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    if(this.fdata.branch_name == 'null')
                        this.fdata.branch_name = '';

                    if(this.fdata.routing_number == 'null')
                        this.fdata.routing_number = '';

                    this.successmsg = null;
                    this.$bvModal.show('bv-modal-bank');
                    this.bank_info_title = "Edit Bank Info";
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },

            deleteBankInfo:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this Bank Info.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/banks/delete', formData).then(function(response){

                            if(response.data.status == true)
                            {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getBankData();
                            }
                            this.showoverlay_list = false;


                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.serverError(error);
                        });
                    }
                })

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                    beneficiary_name: this.bn,
                    account_no: null,
                    bank_name: null,
                    routing_number:null,
                    branch_name:null,
                    swift_code:null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-bank');
                this.bank_info_title ="Add Bank Info";
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay_list = true;
                    let currentObj = this;
                    e.preventDefault();

                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }
                    axios.post(this.$api_url+'/savebankinfo', formData, config)
                            .then(function (response)
                            {
                                this.$bvModal.hide('bv-modal-bank');
                                this.getBankData();
                                this.showoverlay_list = false;
                                this.successmsg = 'Saved!';
                                this.$bvToast.toast(this.successmsg, {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                this.resetForm();
                                this.$validator.reset();

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.showoverlay_list = false;
                                currentObj.serverError(error);
                            });
                });
            },
            updateAllEmployeeBankInfo()
            {
                axios.get(this.$api_url+'/update-all-employee-bank-info')
                        .then(function (response) {
                            console.log(response.data);
                        })
                        .catch(function (error) {

    					   currentObj.output = error;

    				    });
            },

        },
        created: function(){
            this.getBankList();
            this.getBankData();
            //this.updateAllEmployeeBankInfo();
        }
    }
</script>
